import type { FlowNodeResultADT, SendMsgWxRobotActionConfigure } from '@lighthouse/shared'
import { type ActionFlowNode, generateVariableValue } from '@lighthouse/shared'
import { safeToString } from '@lighthouse/tools'
import { t } from 'i18next'

import * as srv from '@/services'

import type { ExecuteActionParams } from '../type'

export const handleWxRobot = async (
    node: ActionFlowNode<SendMsgWxRobotActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    const { text } = config
    const { editorContent, mentionedContent } = text

    const editorContentValue = generateVariableValue({
        innerType: 'TEXT',
        jsonContent: editorContent,
        extraParams: params,
        options: { format: true, useFileUrl: true }
    })
    const resolvedMentionedContent = generateVariableValue({
        innerType: 'TEXT',
        jsonContent: mentionedContent,
        extraParams: params,
        options: { format: true, useFileUrl: true }
    })
    const mentionedList =
        typeof resolvedMentionedContent === 'string'
            ? resolvedMentionedContent.split(',')
            : Array.isArray(resolvedMentionedContent)
            ? resolvedMentionedContent
            : []
    const resolvedText = {
        mentioned_mobile_list: mentionedList,
        content: safeToString(editorContentValue)
    }

    const isSuccess = await srv.activeWxRobotAction({ config: { ...config, text: resolvedText } })

    return {
        type: 'record',
        success: isSuccess
    }
}
